import { render, staticRenderFns } from "./sendGemsModal.vue?vue&type=template&id=f0cc0b54&scoped=true&"
import script from "./sendGemsModal.vue?vue&type=script&lang=js&"
export * from "./sendGemsModal.vue?vue&type=script&lang=js&"
import style0 from "./sendGemsModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./sendGemsModal.vue?vue&type=style&index=1&id=f0cc0b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cc0b54",
  null
  
)

export default component.exports